import { ALTO_CORE_EVENT_NAMES } from './altoCore'
import { ALTO_INSIGHTS_EVENT_NAMES } from './altoInsights'
import { SOURCING_EVENT_NAMES } from './sourcing'

export const EVENT_NAMES = {
  ACCOMMODATION_AGREEMENT_BLOCK_OVERRIDEN:
    'Accommodation Agreement Block overriden',
  ACCOMMODATION_AGREEMENT_NEW_BLOCK_ADDED:
    'New Block added to Accommodation Agreement',
  ALTOVITIAN_SENDS_EMAIL_TO_SUPPLIER: 'AltoVitian sends email to Supplier',
  APPROVAL_PAGE_VIEWED: 'Viewed Approval Page',
  CLICK_ON_SEND_TO_SELF_ON_SEND_TO_SUPPLIER:
    'Click on Send to Self on Send to Supplier',
  CLICK_SAVE_AND_SEND_TO_SUPPLIER: 'Click Save and Send to Supplier',
  CLIENT_EMAIL_SENT: 'Client Email Sent from AltoVitian',
  CLONED_FROM_FAV_BUTTON: 'Property Details cloned from Favourite',
  CLONED_FROM_HISTORY: 'Property Details cloned from history',
  CONSULTANT_EMAIL_SENT: 'Consultant Email Sent from AltoVitian',
  COPY_DETAILS_FROM_SHORTLIST: 'Copy Details from Shortlist',
  EMPLOYEE_EMAIL_SENT: 'Employee Email Sent from AltoVitian',
  EMPLOYEE_EMAIL_SENT_FROM_REVIEW: 'Emailed Employee Housing Options',
  GROUP_HOR_CREATED: 'Created Group Request',
  HOR_CREATED: 'Created Housing Request',
  RATE_CALCULATOR_USED_ON_EDIT_SHORTLIST:
    'Rate Calculator used on Edit Shortlist',
  REPORTING_DASHBOARD_VIEWED: 'Viewed Reporting Dashboard',
  SELF_EMAIL_SENT: 'Self Email Sent from AltoVitian',
  USER_ACTIVATES_ACCOUNT: 'User activates new account',
  USER_CLICK_ON_CLEAR_FILTERS_TOGGLE: 'User click on Clear filters toggle',
  USER_CLICK_ON_GDS_PROFILE_LOCATION_FILTER:
    'User click on GDS profile location filter',
  PROPERTY_ADDED_TO_SHORTLIST_BY_ID: 'Property added to Shortlist by ID',
  LOGIN_USER_WITH_SUPPLIER_ROLE: 'Login user with supplier role',
  CONSULTANT_VIEWED_BOOKING_PAGE: 'Viewed Booking table page',
  CONSULTANT_VIEWED_BOOKING_DETAILS_PAGE: 'Viewed Booking details page',
  CONSULTANT_REQUESTED_BOOKING_CANCELLATION: 'Requested Booking cancellation',
  ...ALTO_INSIGHTS_EVENT_NAMES,
  ...SOURCING_EVENT_NAMES,
  ...ALTO_CORE_EVENT_NAMES,
} as const
